import { ReactNode } from 'react';

interface Props {
    htmlFor?: string;
    children: ReactNode;
    required?: boolean;
}

const Label = ({ htmlFor, children, required }: Props) => (
    <label htmlFor={htmlFor} className="mb-1 inline-block font-sans-2 text-sm font-semibold">
        {children}
        {required && <span className="ml-1 text-red">*</span>}
    </label>
);

export default Label;
